/**
 * Transformer that displays the number of rooms with a proper separator.
 * Fractured numbers are displayed with `_` separator in the framework by default.
 * To display it correctly for users we should replace `_` with `.`.
 * E. g.: `1_5` => `1.5`
 */
export default (kasko) => {
  kasko.addEventListener('form-changed', ({ current, previous }) => {
    const state = kasko.getState();
    const formState = kasko.getFormState();

    if (state.route.state.url !== '/building-info' && state.route.state.url !== '/summary') {
      return;
    }

    if (
      current &&
      previous &&
      current.rooms === previous.rooms &&
      // Update human rooms if it's empty
      current.rooms_human !== undefined
    ) {
      return;
    }

    kasko.dispatchEvent('set-form-input', {
      rooms_human: (formState.rooms || '').replace('_', '.'),
    });
  });
};
